export default __webpack_public_path__ + "static/kevin-mattice-7b8dd0b26ba39c0f1e2aa9dc3ae34508.png";